import { addDays, format, lastDayOfWeek, subDays } from "date-fns";
import { Box, Grid, Text } from "grommet";
import * as React from "react";
import { CalendarViewEvent } from "./CalendarView";
import DayView from "./DayView";
import ScrollContainer from "../components/ScrollContainer";

const WeekView = ({ day, events }: { day: Date; events: CalendarViewEvent[] }) => {
    const [weeksDays, setWeeksDays] = React.useState([] as Date[]);

    React.useEffect(() => {
        let lastDay = lastDayOfWeek(day);
        let firstDay = subDays(lastDay, 6);
        let days = [] as Date[];
        for (let i = 0; i < 7; i++) {
            days.push(addDays(firstDay, i));
        }
        setWeeksDays(days);
    }, [day]);

    return (
        <Box width={"large"} gap="small" fill>
            <Grid columns={{ count: 7, size: "auto" }} gap="small" fill>
                {weeksDays.map((day, i) => (
                    <Text key={"h" + i}>{format(day, "eeee")}</Text>
                ))}
                <ScrollContainer direction={"-y"}>
                    {weeksDays.map((day, i) => (
                        <DayView key={i} day={day} events={events} showTimes={i == 0} />
                    ))}
                </ScrollContainer>
            </Grid>
        </Box>
    );
};

export default WeekView;
